import { Button } from 'base/ui/button';
import { ColoredIcon } from 'base/ui/colored_icon';
import { IconGlobalSection, IconUnlink } from 'base/ui/icons';
import { Inline, SpacerGrow } from 'base/ui/layout';
import { TextTiny, TextTinyLight } from 'base/ui/typography';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SectionEditingActions } from '../editing_actions/section';
import { SectionRef } from '../model';
import styles from './global_sections.css';

export const GlobalSectionsButton = observer(function _GlobalSectionsButton({
  sref,
  sectionEditing,
}: {
  sref: SectionRef;
  sectionEditing: SectionEditingActions;
}) {
  return (
    <>
      {sectionEditing.makeGlobal && (
        <Button
          icon={<ColoredIcon color="colorGreen" icon={IconGlobalSection} />}
          label="Make a global section"
          onClick={sectionEditing.makeGlobal}
        />
      )}
      {sref.type === 'reference' && (
        <GlobalInfoBanner
          count={sectionEditing.globalInstanceCount}
          onUnlink={sectionEditing.unlinkGlobal}
        />
      )}
    </>
  );
});

function GlobalInfoBanner({
  count,
  onUnlink,
}: {
  count: number;
  onUnlink?: () => void;
}) {
  return (
    <div className={styles.banner}>
      <Inline spacing={8} yalign="center">
        <Inline spacing={0} yalign="center">
          <div className={styles.bannerIcon}>
            <IconGlobalSection />
          </div>
          <TextTiny>Global •</TextTiny>
          <TextTinyLight>
            {'\u00a0'}
            {count} instance{count > 1 ? 's' : ''}
          </TextTinyLight>
        </Inline>
        <SpacerGrow />
        {onUnlink && (
          <Button
            size="small"
            variant="tertiary"
            icon={<ColoredIcon color="colorGreen" icon={IconUnlink} />}
            tooltip="Unlink instance"
            tooltipPlacement="vertical"
            onClick={onUnlink}
          />
        )}
      </Inline>
    </div>
  );
}
